import { Injectable, Injector, OnDestroy } from '@angular/core';
import { Plan } from '@docma-mm-core/plan/plan';
import { SearchFilterService } from '@mydocma/component-library/src/lib/search';
import { SearchOptions } from '@mydocma/component-library/src/lib/search/options/search-options';
import { BehaviorSubject } from 'rxjs';
import { debounceTime, distinctUntilChanged, first, map, startWith, switchMap } from 'rxjs/operators';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Structure } from '@docma-mm-core/structure/structure';
import { MmProjectLoaderService } from '../../../mm-project/mm-project-loader.service';
import { copy } from '@mydocma/common/src/lib/deep';

@UntilDestroy()
@Injectable()
export class MmPlansFilterService implements  OnDestroy {

  filterOptions: SearchOptions = null;
  private searchFilterService: SearchFilterService;

  private filterTextSubject = new BehaviorSubject<string>('');
  filterText$ = this.filterTextSubject.asObservable();

  private pinVisibiltySubject = new BehaviorSubject<boolean>(true);
  pinVisibilty$ = this.pinVisibiltySubject.asObservable();

  private filterdPlansSubject = new BehaviorSubject<Plan[]>(null);
  filterdPlans$ = this.filterdPlansSubject.asObservable();

  private filteredPlansEditListSubject = new BehaviorSubject<Plan[]>(null);
  filteredPlansEditList$ = this.filteredPlansEditListSubject.asObservable();

  constructor(
    private readonly projectLoaderService: MmProjectLoaderService,
  ) {}

  ngOnDestroy(): void {
  }

  registerFilter(plans: Plan[]): void {
    const plansInternal = plans.filter(plan => !plan.data.BpPlan || plan.data.BpPlan?.isDisabled === false);
    this.filterdPlansSubject.next(plansInternal);

    this.filterOptions = {
      allowMultipleFilter: false,
      onReady: (searchFilterService) => {
        this.searchFilterService = searchFilterService;
        this.searchFilterService.dataSource = {
          data: plansInternal,
          doesItemPassFilter: (item: Plan, filters: string[]): boolean => {
            let includesAllFilters = true;
            for (const filter of filters) {
              if (item.data?.Description.search(new RegExp(filter, 'i')) === -1 &&
                  item.data?.StructurePath.search(new RegExp(filter, 'i')) === -1) {
                    includesAllFilters = false;
              }
            }
            return includesAllFilters;
          }
        };

        this.searchFilterService.filters$
          .pipe(untilDestroyed(this), debounceTime(250))
          .subscribe({
            next: (filter) => this.filterTextSubject.next(filter.join()),
            error: (error) => console.error(error)
        });

        this.searchFilterService.filteredData$
          .pipe(
            untilDestroyed(this),
            switchMap((filteredPlansData: Plan[]) => this.pinVisibilty$.pipe(map(pinVisibilty => ({filteredPlansData, pinVisibilty})))),
          ).subscribe({
            next: async ({filteredPlansData, pinVisibilty}) => {
                this.filterdPlansSubject.next(!pinVisibilty ? filteredPlansData.filter(plan => plan.pins.length > 0) : filteredPlansData);
            },
            error: (error) => console.error(error)
        });
      }
    };
  }

  async filterPlansByFaultStructure(struct: Structure, allPlans: Plan[]) {
    const rootStrucutre = copy(await this.projectLoaderService.structures.pipe(first()).toPromise()).data;
    let parentStructs : Structure[] = [];
    const planOnCurrentStuct : Plan[] = allPlans.filter(plan => plan.data.Structure.Id === struct.Id);
    if(planOnCurrentStuct.length > 0) {
      this.filteredPlansEditListSubject.next(planOnCurrentStuct);
    } else {
      this.getParentStructs(parentStructs, rootStrucutre[0].findById(struct.Id), rootStrucutre);
      this.filteredPlansEditListSubject.next(allPlans.filter(plan => parentStructs.find(struct => struct.Id === plan.data.Structure.Id)));
    }
    return this.filteredPlansEditListSubject.value;
  }

  private getParentStructs(parentStructs: Structure[], struct, rootStruct): void {
    parentStructs.push(struct)
    if(struct.Parent && struct.Id !== struct.RootId) {
      this.getParentStructs(parentStructs, rootStruct[0].findById(struct.Parent.Id),rootStruct)
    }
  }

  toggleVisiblePlans(): void {
    this.pinVisibiltySubject.next(!this.pinVisibiltySubject.value);
  }

  get filteredPlans(): Plan[] {
    return this.filterdPlansSubject.value;
  }

}
